/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface WidgetRoleOrder
 */
export interface WidgetRoleOrder {
    /**
     * 
     * @type {string}
     * @memberof WidgetRoleOrder
     */
    role: string;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof WidgetRoleOrder
     */
    sortOrder: ApiUserTasksGetPageParameter;
}

/**
 * Check if a given object implements the WidgetRoleOrder interface.
 */
export function instanceOfWidgetRoleOrder(value: object): value is WidgetRoleOrder {
    if (!('role' in value) || value['role'] === undefined) return false;
    if (!('sortOrder' in value) || value['sortOrder'] === undefined) return false;
    return true;
}

export function WidgetRoleOrderFromJSON(json: any): WidgetRoleOrder {
    return WidgetRoleOrderFromJSONTyped(json, false);
}

export function WidgetRoleOrderFromJSONTyped(json: any, ignoreDiscriminator: boolean): WidgetRoleOrder {
    if (json == null) {
        return json;
    }
    return {
        
        'role': json['role'],
        'sortOrder': ApiUserTasksGetPageParameterFromJSON(json['sortOrder']),
    };
}

export function WidgetRoleOrderToJSON(json: any): WidgetRoleOrder {
    return WidgetRoleOrderToJSONTyped(json, false);
}

export function WidgetRoleOrderToJSONTyped(value?: WidgetRoleOrder | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'role': value['role'],
        'sortOrder': ApiUserTasksGetPageParameterToJSON(value['sortOrder']),
    };
}

